import { handleize } from '@/lib/utils'
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      ready: false,
      currentServiceProducts: [],
    }
  },
  computed : {
    ...mapState('services', ['servicesList', 'allProducts', 'cartItems', 'serviceProducts']),
    ...mapGetters(['validSubscription']),
    serviceHandle () {
      return this.$route.params.id
    },
    primaryServices () {
      return this.serviceProducts
    },
    requiresFileUpload () {
      return this.cartLineItems.some((item) => item.product.showfileupload)
    },
    makePlansServiceID () {
      return this.cartLineItems.reduce((id, item) => {
        if (id) return id
        return item.product.makeplans_id
      }, null)
    },
    serviceDetails () {
      if (!this.servicesList) return null
      return this.servicesList.find(({ title }) => this.serviceHandle ===  handleize(title))
    },
    isLoggedIn () {
      return this.user && this.user.uid
    },
    user() {
      return this.$store.getters.user
    },
    stripeKey () {
      return process.env.STRIPE_KEY
    },
    cartLineItems () {
      const items = this.cartItems.map((id) => {
        const product = this.serviceProducts.find(({ data }) => data.stripe_price_id === id)
        const matchingStripe = this.allProducts.find(({ externalId }) => externalId === id)
        return {
          product: product ? product.data : null,
          details: matchingStripe
        }
      })
      console.log(items)
      return items
    },
    total () {
      const total = this.cartLineItems.reduce((total, item) => {
        if (!item || !item.details) return total
        return total + item.details.unitAmount
      }, 0)
      return this.formatMoney(total)
    }
  },
  methods: {
    formatMoney (total) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total/100)
    },
    ...mapActions('services', ['fetchAllProducts']),
    async fetchServiceData () {
      const services = await this.$prismic.client.query([
          this.$prismic.Predicates.at('document.type', 'services'),
          this.$prismic.Predicates.at('document.tags', this.serviceDetails ?  [this.serviceDetails.tagoptions] : [])
        ], { pageSize : 100 })
      this.currentServiceProducts = services.results
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Services/service-item-mixins.js